import React from 'react';

interface ShieldIconProps {
    className?: string;
}

const ShieldIcon: React.FC<ShieldIconProps> = ({ className }) => {
    return (
        <img
            src="/logo.png"
            alt="QuickMask Logo"
            className={['block object-cover', className].filter(Boolean).join(' ')}
        />
    );
};

export default ShieldIcon;